
export const luminTenants = {
    lumin: "lumin",
    service1: "service1"
};

export const isLuminTenant = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(luminTenants).includes(props);
    }
    return Object.values(luminTenants).includes(props?.state?.theme?.values?.tenantFullName);
}